<template>
  <div class="jackpots">
    <div v-if="loading"
         class="loader">
      <div class="bar"></div>
    </div>
    <Header @load="loadPage"
            @search="searchData"
            @setFilters="setFilters">
    </Header>
    <div class="jackpotsData">
      <Table :descending="descending"
             :data="jackpots"
             :headers="headers"
             :selected="selectedColumns"
             :sortColumn="paginationConfig.sortBy"
             :sortable="true"
             @sortBy="sortRoundsBy"
             :type="'list'">
      </Table>
      <Pagination :page="page"
                  :row="pagination.rowsPerPage"
                  :rows="rowsPerPageItems"
                  :totalItems="totalCount"
                  :totalPages="totalPages"
                  @setPages="setPagination">
      </Pagination>
    </div>
    <InfoMessage></InfoMessage>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { map } from 'lodash';
import { paginable } from '../mixins';
import Header from './Header';
import Pagination from './Pagination';
import Table from './Table';
import InfoMessage from './InfoMessage';

export default {
  name: 'Jackpots',
  components: {
    Header,
    InfoMessage,
    Pagination,
    Table,
  },
  mixins: [
    paginable,
  ],
  data() {
    return {
      headers: [
        { value: 'id' },
        { value: 'barcode' },
        { value: 'createdAt' },
        { value: 'jackpotWinAmount' },
      ],
      descending: false,
      dateFrom: null,
      dateTo: null,
      page: null,
      search: null,
      selectedColumns: [],
      totalPages: null,
    };
  },
  computed: {
    ...mapGetters([
      'jackpots',
      'paginationConfig',
      'platformTimezoneOffset',
      'translations',
      'wheel',
    ]),
    apiFilters() {
      return {
        wheelId: this.wheel.id,
        wheelAccountId: this.wheel.wheelAccountId,
        dateFrom: this.dateFrom,
        dateTo: this.dateTo,
        timezoneOffset: this.platformTimezoneOffset,
      };
    },
  },
  watch: {
    apiFilters() {
      this.loadPage();
    },
  },
  mounted() {
    this.selectedColumns = map(this.headers, () => true);
  },
  methods: {
    ...mapActions([
      'setInfoMessage',
    ]),
    loadPage() {
      if (this.wheel.id) {
        this.loading = true;
        this.$store.dispatch('loadJackpots', this.apiParams).then((result) => {
          this.setInfoMessage(null);
          if (!result.jackpotWinnings.length) {
            this.setInfoMessage(this.translations.tableNoDataText);
          }
          this.totalPages = result.pagination.totalPages;
          this.page = result.pagination.page;
          this.totalCount = result.pagination.totalCount;
          this.descending = this.pagination.descending;
        }).finally(() => {
          this.loading = false;
        });
      }
    },
    sortRoundsBy(value) {
      this.pagination.sortBy = value;
      this.pagination.descending = !this.pagination.descending;
      this.loadPage();
    },
    setPagination(value) {
      this.pagination.page = value.page;
      this.pagination.rowsPerPage = value.pageSize;
      this.loadPage();
    },
    setFilters(value) {
      this.dateFrom = value.dateFrom;
      this.dateTo = value.dateTo;
    },
    searchData(value) {
      this.search = value;
      this.loadPage();
    },
  },
};
</script>
<style lang="scss" scoped>
.jackpotsData {
  padding: 10px;
  width: 100%;
  .pagination {
    width: 99.9%;
  }
}
::v-deep table th {
  width: 25%;
}
</style>
